


























































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import { ChoiceOption } from '@/interfaces';
import FieldDefs from './FieldDefs';
import SignatureDialog from '@/components/SignatureDialog.vue';
import EventOverview from '@/components/EventOverview.vue';
import SendEmailDialog from '@/components/SendEmailDialog.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';


interface ChoiceOption2 {
  text: string;
  value: number | string;
  is_internal_company: boolean;
}

@Component({
  components: {
    SignatureDialog,
    EventOverview,
    SendEmailDialog,
    ConfirmDialog
  }
})
export default class TransportVoucherDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public eventFieldName = this.getTableCfg(this.tableCfg, 'eventFieldName');
  public eventMap = this.getTableCfg(this.tableCfg, 'eventMap');

  public showSignature(props) {
    const layout: any = this.$refs.layout;
    if (layout) {
      return !props.isNew && layout.customEditable(props.rec);
    }
    return false;
  }

  public showFile(props) {
    return this.roleCheckIsA('manager|dispatch') && !props.isNew && !props.isEdit;
  }

  public showCloseSheet() {
    if (!this.roleCheckAPI('transportvoucher', 'closevoucher')) {
      return false;
    }
    const layout: any = this.$refs.layout;
    if (layout && layout.rec) {
      //  console.log('showCloseSheet', layout.rec.is_closed, layout.rec.is_locked);
       return !layout.rec.is_closed && !layout.rec.is_locked;
    } else {
      return false;
    }
  }
  public copyFinalCustomerName(rec) {
    const ref: any = this.$refs.ordering_customer_id;
    if (ref) {
      rec.final_customer_name = ref.findOptionValue();
    }
  }

  public showSendMail() {
    if (!this.roleCheckAPI('transportvoucher', 'getmailtemplate')) {
      return false;
    }
    const layout: any = this.$refs.layout;
    if (layout && layout.rec) {
      //  console.log('showSendMail', layout.rec.is_closed, layout.rec.is_locked);
       return !layout.rec.is_locked;
    } else {
      return true;
    }
  }


   public recLoaded(rec) {
    const responsible_signature: any = this.$refs.responsible_signature;
    const driver_signature: any = this.$refs.driver_signature;
    responsible_signature.setEmpty(rec.responsible_signature == null);
    driver_signature.setEmpty(rec.driver_signature == null);
  }

  public emailWasSent(id) {
    const ref: any = this.$refs.layout;
    this.$set(ref.rec, 'is_locked', true);
  }

  public async closeMe(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/closevoucher');
    this.$set(rec, 'is_closed', true);
  }
  public async signature_updated() {
    const id = this.$route.params.id;
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(id) + '/makepdf');
  }

}
